import axiosInstance from 'core/network/axiosInstance'

export interface UserApiResponse {
  id: string
  keycloak_id: string
  name: string
  role: string
  phone: string
  email?: string
  status: string
  created_at: string
  updated_at: string
}

export interface UsersListApiResponse {
  skip: number
  limit: number
  total: number
  data: UserApiResponse[]
}

export interface GetUsersApiParams {
  skip: number
  limit: number
  role?: string
  search?: string
}

export interface RegisterUserApiRequest {
  name: string
  phone: string
  email: string
  role: string
  password?: string
}

// All fields optional — the backend only overwrites what's present in the body.
export interface UpdateUserApiRequest {
  name?: string
  phone?: string
  role?: string
  status?: string
}

class UserApiDatasource {
  async getUsers(params: GetUsersApiParams): Promise<UsersListApiResponse> {
    const { data } = await axiosInstance.get<UsersListApiResponse>('/api/v1/users', { params })
    return data
  }

  async getUserById(id: string): Promise<UserApiResponse> {
    const { data } = await axiosInstance.get<UserApiResponse>(`/api/v1/users/${id}`)
    return data
  }

  async registerUser(payload: RegisterUserApiRequest): Promise<UserApiResponse> {
    const { data } = await axiosInstance.post<UserApiResponse>('/api/v1/users/register', payload)
    return data
  }

  async updateUser(id: string, payload: UpdateUserApiRequest): Promise<UserApiResponse> {
    const { data } = await axiosInstance.put<UserApiResponse>(`/api/v1/users/${id}`, payload)
    return data
  }
}

export const userApiDatasource = new UserApiDatasource()
